import { VisualMapComponentOption } from 'echarts';
import { MANTY_GREEN, MANTY_RED } from 'styles/theme';

/**
 * For the fixed threshold eChart alert status graph, return the Visual Map options so that
 * all value that result in a TRIGGERED state are drawn in red, and in green otherwise.
 * @param lastThresholdValue - The last value of the threshold (almost always the current value).
 * @param isGreater - if the threshold operation is greater.
 */
export const getVisualMap = (
    lastThresholdValue: number | undefined,
    isGreater: boolean,
): VisualMapComponentOption | undefined => {
    if (lastThresholdValue !== undefined) {
        const visualMap = {
            show: false,
            type: 'piecewise',
            //A bit hacky solution due to echarts bug. This workaround is mentionned in echarts Github
            //https://github.com/apache/echarts/issues/5801#issuecomment-1505818039
            pieces: [
                {
                    min: lastThresholdValue + 0.000001,
                    color: isGreater ? MANTY_RED : MANTY_GREEN,
                },
                {
                    max: lastThresholdValue,
                    color: isGreater ? MANTY_GREEN : MANTY_RED,
                },
            ],
            outOfRange: {
                color: MANTY_GREEN,
            },
        };
        return visualMap;
    }
    return undefined;
};
